export default __webpack_public_path__ + "d91f369f1be5c5a0af7f5a20ca6b5c46.svg";